(() => {
  const controllerKey = '__saguaroFlagshipCutawayV1';
  if (window[controllerKey]) {
    window[controllerKey].refresh();
    return;
  }

  const sectionSelector = '[data-cutaway-story]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new Set();
  const controllers = new WeakMap();
  let frame = 0;

  const clamp = value => Math.max(0, Math.min(1, value));
  const getSections = () => [...observed].filter(section => section.isConnected);

  const resizeObserver = 'ResizeObserver' in window
    ? new ResizeObserver(() => { getSections().forEach(fitContent); queueUpdate(); })
    : null;

  function measure(section) {
    const stage = section.querySelector('.sfc-stage');
    return {
      start: section.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(stage).top) || 0),
      travel: Math.max(1, section.offsetHeight - stage.offsetHeight)
    };
  }

  function update() {
    frame = 0;
    getSections().forEach(section => {
      const stage = section.querySelector('.sfc-stage');
      if (!stage) return;
      const {start, travel} = measure(section);
      const raw = clamp((window.scrollY - start) / travel);
      const progress = clamp((raw - 0.1) / 0.72);
      const visibleProgress = reducedMotion.matches ? (progress >= 0.5 ? 1 : 0) : progress;
      const selected = section.querySelector('[data-color-button]:checked');
      const colorId = selected?.value || section.querySelector('[data-color-pair]')?.dataset.colorPair;
      const pair = [...section.querySelectorAll('[data-color-pair]')].find(item => item.dataset.colorPair === colorId);
      const visual = section.querySelector('[data-cutaway-visual]');
      const announcement = section.querySelector('[data-color-announcement]');

      section.querySelectorAll('[data-color-pair]').forEach(item => {
        item.hidden = item !== pair;
      });
      section.style.setProperty('--sfc-reveal', visibleProgress.toFixed(4));
      section.style.setProperty('--sfc-layer-opacity', visibleProgress > 0 ? '1' : '0');
      section.style.setProperty('--sfc-mask-start', `${(100 - visibleProgress * 112).toFixed(2)}%`);
      section.style.setProperty('--sfc-mask-end', `${(112 - visibleProgress * 112).toFixed(2)}%`);
      section.dataset.progress = progress.toFixed(4);
      section.dataset.color = colorId || '';

      if (visual && selected) {
        const name = selected.dataset.colorName || '';
        const view = visibleProgress <= 0.01 ? 'esterna' : visibleProgress >= 0.99 ? 'interna' : 'in transizione';
        visual.setAttribute('aria-label', `Vista ${view} · ${name}`);
      }
      if (announcement && selected && section.dataset.announcedColor !== selected.value) {
        section.dataset.announcedColor = selected.value;
        announcement.textContent = `Colore selezionato: ${selected.dataset.colorName || ''}.`;
      }
    });
  }

  function queueUpdate() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }

  function goToInterior(section, target) {
    const {start, travel} = measure(section);
    const ratio = Number(target) === 0 ? 0 : 0.84;
    window.scrollTo({
      top: start + travel * ratio,
      behavior: reducedMotion.matches ? 'instant' : 'smooth'
    });
  }

  function refresh(root = document) {
    const sections = [];
    if (root instanceof Element && root.matches(sectionSelector)) sections.push(root);
    if (root.querySelectorAll) sections.push(...root.querySelectorAll(sectionSelector));
    sections.forEach(section => {
      if (!observed.has(section)) {
        observed.add(section);
        const controller = new AbortController();
        controllers.set(section, controller);
        section.addEventListener('change', event => {
          if (event.target.matches('[data-color-button]') && event.target.checked) update();
        }, {signal: controller.signal});
        section.addEventListener('click', event => {
          const button = event.target.closest('[data-target-progress]');
          if (button) goToInterior(section, button.dataset.targetProgress);
        }, {signal: controller.signal});
        if (resizeObserver) resizeObserver.observe(section.querySelector('.sfc-copy'));
        fitContent(section);
      }
    });
    queueUpdate();
  }

  document.addEventListener('shopify:section:load', event => refresh(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target;
    const sections = [];
    if (root instanceof Element && root.matches(sectionSelector)) sections.push(root);
    if (root.querySelectorAll) sections.push(...root.querySelectorAll(sectionSelector));
    sections.forEach(section => {
      observed.delete(section);
      controllers.get(section)?.abort();
      controllers.delete(section);
      if (resizeObserver) resizeObserver.unobserve(section.querySelector('.sfc-copy'));
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const section = event.target.closest(sectionSelector);
    if (!section) return;
    const input = [...section.querySelectorAll('[data-color-button]')].find(item => item.dataset.blockId === event.detail?.blockId);
    if (input) { input.checked = true; update(); }
  });
  document.addEventListener('shopify:section:reorder', queueUpdate);
  window.addEventListener('scroll', queueUpdate, {passive: true});
  window.addEventListener('resize', () => { getSections().forEach(fitContent); queueUpdate(); }, {passive: true});
  reducedMotion.addEventListener('change', queueUpdate);

  window[controllerKey] = {refresh};
  refresh();
  document.fonts?.ready.then(() => { getSections().forEach(fitContent); queueUpdate(); });
  function fitContent(section) {
    const stage = section.querySelector('.sfc-stage');
    const copy = section.querySelector('.sfc-copy');
    if (!stage || !copy) return;
    const css = getComputedStyle(stage);
    const space = (parseFloat(css.paddingTop) || 0) + (parseFloat(css.paddingBottom) || 0);
    const imageSpace = matchMedia('(max-width: 700px)').matches ? 220 + (parseFloat(css.rowGap) || 0) : 0;
    const minHeight = Math.ceil(copy.getBoundingClientRect().height + space + imageSpace) + 'px';
    if (section.style.getPropertyValue('--sfc-content-height') !== minHeight) section.style.setProperty('--sfc-content-height', minHeight);
  }
})();
